import { PopupDialogAction, PopupDialogObject } from '../models/popup-dialog-object';
import { WweErrorCode } from '../models/wwe-errors/wwe-error-code.model';
import { WweErrorPortfolioDetails } from '../models/wwe-errors/wwe-security-details-partial-error';


export class WweErrorUtil {

	// This builder is specifically for the BPAS engagements flow
	public static buildViewPortfolioInEditorAction(firstFailedPortfolioId: string, label: string): PopupDialogAction {
		const options: any = {
			label: label,
			type: 'view_portfolio_editor',
			reload: false,
			portfolioId: firstFailedPortfolioId
		};
		return PopupDialogAction.create(options);
	}

	public static configurePopupDisplayForSecurityError(errorPortfolios: WweErrorPortfolioDetails[], dialogErrorMessage: PopupDialogObject): void {
		dialogErrorMessage.disableClose = false;
		dialogErrorMessage.listings = errorPortfolios.map(errorPortfolio => {
			return { iconType: 'times', description: errorPortfolio.description };
		});
	}

	public static logSecurityErrorsToConsole(errorKey: string, error: WweErrorCode, configName: string, defaultMessage): void {
		const message = error.description ? error.description : defaultMessage;
		console.error(`There was an error while retrieving data for config: ${configName} and portfolioId: ${errorKey}`, `${error.code}: ${message}`);
	}
}
